import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Breadcrumb} from './breadcrumb';
import {TypeUtils} from '../../../utils/type-utils';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent implements OnInit {

  @Input() breadcrumbs: Breadcrumb[];
  types = TypeUtils;

  constructor(
    private router: Router
  ) {
  }

  ngOnInit(): void {
  }

  breadcrumbClicked(bc: Breadcrumb) {
    if (!bc.active && !bc.disabled) {
      this.router.navigateByUrl(bc.targetUrl).then(() => {
      });
    }
  }

}
